<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
        <div class="container-fluid" :style="paddinBottomDinamic">
            <div class="row">
                <div class="col-6">
                    <Form ref="ABC" @submit="postAnexoChamado">
                        <div class="mt-1">
                            <input-upload ref="inputuploadv2" :url-upload="urlAnotacaoAnexoUpload" @on-save="uploadFile" :labelText="'Anexo do Chamado'" />
                            <Field name="urlAnexo" label="Anexo" type="hidden"  v-model="ChamadoAnexoCrud.urlAnexo" />
                        </div>
                        <div>
                            <button type="submit" class="btn btn-red" style="width: 100%" form="form"
                                v-on:click="postAnexoChamado">
                                <i class="fas fa-save pe-2"></i>
                                Salvar Anexo Chamado</button>
                        </div>
                    </Form>
                </div>

                <div class="col-6">
                    <DataTable v-if="url_chamado_anexo != ''" :url_ajax="url_chamado_anexo" :ajax_set_result="setTable" @grid_refreshed="gridRefreshed"
                               :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                               :footer_fixed="true" :headers="headersTable" :pBtnsSlot="true" :is_NotLoading="NotLoading" :request_api="'comercial'">
                        <template v-slot:BtnSlot="item">
                            <button type="button" class="btn-red btn-baixar" @click="getAnexo(item.row.urlAnexo)">
                                <span class="">Baixar</span>
                            </button>
                        </template>
                    </DataTable>                   
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import InputUpload from '../../../../components/App/Input_Upload.vue'
    import DataTable from './../../../../components/App/Datatable.vue';

    export default {
        name: 'Anotações',
        components: {
            OcorrenciaInfo,
            InputUpload,
            DataTable
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                ocorrencia: {},

                filtro: [
                    { active: true },
                ],
                refresh_grid: false,

                headersTable: [
                    { class: 'col-4 ', name: 'nmAnexo', text: 'Nome Anexo', order: 0 },
                    { class: 'col-3 ', name: 'dsLoginConsultor', text: 'Usuário ou Consultor', order: 0 },
                    { class: 'col-3 ', name: 'dtInclusao', text: 'Data Inclusão', order: 0 },
                    { class: 'col-1', name: 'btns', text: '', actions: true, }
                ],
                ChamadoAnexoCrud: {
                    idChamado: 0,
                    urlAnexo: ''
                },
                showErrorMessage: false,

                urlAnotacaoAnexoUpload: process.env.VUE_APP_ROOT_COMERCIAL_API + '/ChamadoAnexo/PostUploadAnexo',
                url_chamado_anexo: ''
            }
        },
        computed: {
        },
        methods: {
            reloadGrid() {
                let $this = this;

                $this.refresh_grid = true;
            },
            setTable(result) {
                return result;
            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
            },
            zerarInformacoes() {
                this.ChamadoAnexoCrud = {
                    idChamado: 0,
                    urlAnexo: '',
                };
                this.tipoAnotacaoSelected = { idTipoAnotacao: 0 }
                this.showErrorMessage = false;

            },
            uploadFile(url) {
                this.ChamadoAnexoCrud.urlAnexo = url;
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.url_chamado_anexo = process.env.VUE_APP_ROOT_COMERCIAL_API + '/ChamadoAnexo/Get?id=' + $this.ocorrencia.idChamado;
                    $this.refresh_grid = true;
                })
            },
            postAnexoChamado() {
                let $this = this;

                $this.$refs.ABC.validate()
                    .then(isValid => {
                        if (isValid.valid) {

                            $this.ChamadoAnexoCrud.idChamado = $this.ocorrencia.idChamado;


                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ChamadoAnexo/Post', $this.ChamadoAnexoCrud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.reloadGrid();
                                    $this.zerarInformacoes();
                                    $this.$refs.inputuploadv2.resetVariaveis();

                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });

                            $this.showErrorMessage = false;


                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            getAnexo(value) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Amazon/GetDownload?url=' + value, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    window.open(response.data.data, "_blank");
                })
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        created() {
        },
        mounted() {
            this.getOcorrencia();
        },
        updated() {
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia(newVal);
            },
        },
    }

</script>

<style scoped lang="scss">
    .mt-35 {
        margin-top: 30px;
    }

    .file-campo {
        border: 1px dashed #f4f4f4;
    }

    .btn-green {
        font-weight: 700;
        border-radius: 5px !important;
    }

    .btn-red {
        border-radius: 5px !important;
    }



    .line-card {
        //border-radius: 10px 0px 0px 10px;
        max-width: 10px;
        margin-left: -3px;
        margin-top: -1px;
        margin-bottom: -2px;
    }

    .bg-color-red {
        background-color: #AB0000;
    }

    .bg-color-green {
        background: #34A853;
    }

    .icon-size {
        height: 50px;
        color: #34A853;
    }
</style>